export default __webpack_public_path__ + "static/media/chev-left-white.9774c618.svg";